export enum AlcoholCertificationsStatusTypes {
  COMPLETED = 'completed',
  INCOMPLETE = 'incomplete',
  PENDING_APPROVAL = 'pending_approval',
  REJECTED = 'rejected'
}
